import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';

import { isTemplateRefInstance } from '../utils/helpers';
import { isNonEmptyString } from '../../../utils';
import { ISelectedRangeLabel } from '../utils/types';
import { PhxFocusableItemDirective } from '../phx-focusable-item.directive';
import { KeyboardKeys } from './../../../helpers/KeyboardKeys.enum';
import { Bullet20 } from './../../icon/icon-map';

enum FOOT_ACTIONS {
  CLEAR,
  RESET
}

@Component({
  selector: 'phx-date-picker-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-date-picker-footer',
    '[attr.tabindex]': 'selectedDateLabels?.from ? 0: null',
    '(focus)':'onWrapperFocus()',
  },
})
export class PhxDatePickerFooterComponent {
  @Input() selectedDateLabels: ISelectedRangeLabel = null;
  @Input() clearDisabled: boolean = false;
  @Input() hideClearButton: boolean = false;
  @Input() extraFooter?: TemplateRef<void> | string;
  @Input() rangeQuickSelector: TemplateRef<any> | null = null;
  @Input() showResetButton: boolean = false;
  @Input() isNonDefaultRangeSelected: boolean = false;

  @Output() readonly onClear = new EventEmitter<void>();
  @Output() readonly onReset = new EventEmitter<void>();
  // TODO: feedback by leadership to remove date labels as its redundant, Zain adeel instruct to hide it for now.
  public showSelectedDateLabels: boolean = false;
  public readonly footerActions = FOOT_ACTIONS;
  public Bullet20Icon: string = Bullet20;

  @ViewChildren(PhxFocusableItemDirective)
  private focusableItems: QueryList<PhxFocusableItemDirective>;

  public get extraFooterType(): 'refType' | 'stringType' {
    if (isTemplateRefInstance(this.extraFooter)) return 'refType';
    else if (isNonEmptyString(this.extraFooter)) return 'stringType';
  }

  constructor() {}

  public onWrapperFocus(): void {
    this.focusableItems.first.focus();
  }

  public onKeydown(event: KeyboardEvent, action = this.footerActions.CLEAR): void {
    if(event.code === KeyboardKeys.ENTER || event.code === KeyboardKeys.SPACE) {
      event.preventDefault();
      if (action === this.footerActions.CLEAR) {
        this.onClear.emit();
      } else if (action === this.footerActions.RESET) {
        this.onReset.emit();
      }
    }
  }
}
